module.exports = __webpack_public_path__ + "img/sbzc_12.ee23a141.jpg";